import { cartFromOrderAddHandler, cartItemAddHandler, cartLookupHandler } from './cart-method-handlers';
import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import { cartItemClearAddHandler } from './cart-item-clear-handler';
import { OrderEditMethods } from '../order-edit/order-edit-method-list';
import { MethodPropertiesKey } from '../../shared/consts';

export enum CartMethods {
  Lookup = 'cartLookup',
  ClearAdd = 'cartItemClearAdd',
}

export const CART_HANDLER_LIST: MethodHandler = {
  [CartMethods.Lookup]: cartLookupHandler,
  [OrderEditMethods.CartFromOrderAdd]: cartFromOrderAddHandler,
  [OrderEditMethods.CartItemAdd]: cartItemAddHandler,
  [CartMethods.ClearAdd]: cartItemClearAddHandler,
};

export const CART_PROPERTIES_LIST: MethodProperties = new Map([
  [
    CartMethods.Lookup,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    OrderEditMethods.CartFromOrderAdd as string,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    OrderEditMethods.CartItemAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    CartMethods.ClearAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
]);
